export default __webpack_public_path__ + "static/media/LEVEL19.da2cb12d.png";